import type React from 'react';
import { Box, Breadcrumbs, RiMapPinLine } from '@itandi/itandi-bb-ui';
import cx from 'clsx';
import type { ComponentProps } from 'react';
import Styles from './DealLayoutHeader.module.scss';
import type { Deal } from '~/models/Deal';
import { DealTypeLabel } from '~/components/common/parts/label/DealTypeLabel';
import { MEDIA_QUERY, useMediaQuery } from '~/hooks/useMediaQuery';
import { SimpleHeaderVendorSP } from './simple_header/SimpleHeaderVendorSP';

type Props = {
  deal: Deal;
  items: ComponentProps<
    typeof Breadcrumbs | typeof SimpleHeaderVendorSP
  >['items'];
  useSimpleSpHeader: boolean;
};

export const DealLayoutHeaderVendor: React.FC<Props> = ({
  deal,
  items,
  useSimpleSpHeader
}: Props) => {
  const { match: isSp, isLoaded: windowLoaded } = useMediaQuery(MEDIA_QUERY.sp);
  if (!windowLoaded) {
    return null;
  }
  return (
    <>
      {useSimpleSpHeader && isSp ? (
        <SimpleHeaderVendorSP deal={deal} items={items} />
      ) : (
        <div className={Styles.DealHeader} id="deal_header">
          <div className={Styles.HeaderLeftContent}>
            <Box marginBottom={16}>
              <Breadcrumbs items={items} />
            </Box>
            <div className={Styles.HeaderElements}>
              <div className={Styles.AlignCenter}>
                <DealTypeLabel
                  dealSubtype={deal.dealSubtype}
                  dealType={deal.dealType}
                />
              </div>
              <div>
                <h1 className={Styles.RoomName}>
                  {deal.name} {deal.roomNumber}
                </h1>
              </div>
              <div className={cx(Styles.AlignCenter, Styles.DealAddress)}>
                <RiMapPinLine className={Styles.Icon} />
                {deal.address}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
